import qs from "qs";
import { localization } from "@/lib/mapper";

export class NoticeClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/notices`;
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async get(id, language) {
    const headers =
      this.language === localization.TH
        ? { Authorization: `Bearer ${localStorage.getItem("accessToken")}` }
        : {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "x-accept-language": language
        };

    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url, { headers });

    return response;
  }

  async post(data) {
    const url = `${this.baseURL}`;

    const response = await this.httpClient.request("post", url, {
      data
    });

    return response;
  }

  async put(id, data) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("put", url, {
      data
    });

    return response;
  }

  async putLanguage(id, data, language) {
    const headers =
      this.language === localization.TH
        ? { Authorization: `Bearer ${localStorage.getItem("accessToken")}` }
        : {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "x-accept-language": language
        };

    const url = `${this.baseURL}/${id}/translation`;

    const response = await this.httpClient.request("put", url, {
      headers,
      data
    });

    return response;
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/communications/notices.js